import styled from 'styled-components';
import { Paragraph } from '@components/Typos/Typos.s';
import { darkgray, veryLightgray } from '@styles/colors';
import { largeLayout } from '@styles/layout';

export const Wrapper = styled.section`
  margin-top: -200px;
  padding-top: 100px;
  min-height: 400px;
  z-index: 200;
  background: white;
  position: relative;
  text-align: center;
  padding-bottom: 60px;
`;

export const SpacedParagraph = Paragraph.extend`
  margin: 4rem;
  color: ${darkgray};
`;

export const NameParagraph = Paragraph.extend`
  font-size: 1.25rem;
  margin-bottom: 10px;
`;

export const JobParagarph = Paragraph.extend`
  color: ${veryLightgray};
  font-size: 1rem;
  margin-top: -0.7rem;
`;

export const AllGeniusWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: ${largeLayout.getSize(8)}px;
  margin: 0 auto;
`;

export const GeniusWrapper = styled.div`
  width: ${largeLayout.getSize(2)}px;
`;

type GeniusImageWrapperProps = {
  src: string
};

export const GeniusImageWrapper = styled.div`
  width: 80px;
  height: 80px;
  background-image: url('${(props: GeniusImageWrapperProps) => props.src}');
  background-size: cover;
  overflow: hidden;
  border-radius: 100%;
  margin: 0 auto;
`;



// WEBPACK FOOTER //
// src/app/src/components/SectionGenius/SectionGenius.s.ts